import Model from '../models/model';

const model = new Model({
	name: 'Item',
	api: 'Items',
	idProperty: 'id',
	defaultSort: 'CreatedDate DESC',
	disableAdd: true,
	disableDelete: true,
	formTitleField: 'ItemName',
	title: 'Items',
	showGridRefreshBtn: true,
	columns: [
		{ header: 'UniqueId', field: 'ItemUniqueId', keyColumn: true, hidden: true },
		{ header: 'HospitalId', field: 'HospitalId', width: 150, hidden: true },
		{ field: 'ItemName', width: 150 },
		{ field: 'ItemType', width: 150 },
		{ field: 'ItemModel', width: 150 },
		{ field: 'MaxHangTime', width: 150 },
		{ field: 'SerialNumber', header: 'SNo', width: 150, hidden: true },
		{ header: 'Active', field: 'ActiveYN', type: 'bool', width: 120, default: true },
		{ field: 'ItemCodes', width: 500 },
		{ field: 'CreatedDate', type: 'dateTime', width: 180 },
		{ field: 'LastUpdateDate', type: 'dateTime', width: 180 }
	]
});

export default model.createFormBase();